const actions = {
    SET_DATA: 'attributesTypes/SET_DATA',
    GET_DATA: 'attributesTypes/GET_DATA',
};

export default actions
